exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_wks-ext.js
// module id = 26
// module chunks = 0